import { RequestBuilder } from '../request_builder'

export class WithdrawalsRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'request/withdrawals'
  }

  forDestAsset (asset) {
    if (asset && asset.length > 0) this.addQuery('dest_asset_code', asset)
    return this
  }

  forState (state) {
    if (state && state > 0) this.addQuery('state', state)
    return this
  }

  forRequestor (requestor) {
    if (requestor && requestor.length > 0) this.addQuery('requestor', requestor)
    return this
  }

  forTimeRange ({from, to}) {
    if (from) this.addQuery('from', from)
    if (to) this.addQuery('to', to)
    return this
  }
  forWithdrawalType (withdrawalType) {
    if (withdrawalType && withdrawalType.length > 0) this.addQuery('withdrawal_type', withdrawalType)
    return this
  }
  restrict ({notaid, withdrawable, cashable}) {
    if (notaid) this.addQuery('notaid', true)
    if (withdrawable) this.addQuery('withdrawable', true)
    if (cashable) this.addQuery('cashable', true)
    return this
  }

  forPage ({order, by, limit}) {
    if (order) {
      this.addQuery('order', order)
      if (by) this.addQuery('by', by)
    }
    if (limit && limit > 0) this.addQuery('limit', limit)
    return this
  }

  cursor (cursor) {
    if (cursor !== undefined && cursor > 0) {
      this.addQuery('cursor', cursor)
    }
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/withdrawals_request_builder.js